<div class="ask-panel">
    <div class="ask-panel__head">
        <span class="ask-panel__icon">
            <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
        </span>
        <div class="ask-panel__head-text">
            <p class="ask-panel__title">{{ title }}</p>
            <p class="ask-panel__description">{{ description }}</p>
        </div>
    </div>

    <div class="ask-panel__input-wrapper">
        <textarea class="ask-panel__input" [placeholder]="placeholder" [attr.maxlength]="maxLength" [disabled]="disabled"
            [value]="value" (keyup.enter)="onEnter($any($event.target).value)"></textarea>
        <span class="ask-panel__counter">{{ value.length }} / {{ maxLength }}</span>
    </div>

    <div class="ask-panel__helper" *ngIf="helperText">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ helperText }}</span>
    </div>
</div>
<!-- Display the element type UI component to render based on the AI report JSON response -->
<ng-container *ngIf="elementType">
    <div *ngIf="elementType=='filter'">
        <app-inbuilt-filters-v2 [Temp]="true" [showView]="true" [elementData]="el"></app-inbuilt-filters-v2>
    </div>

    <div *ngIf="elementType=='table'">
        <app-inbuilt-table-v2 [Temp]="true" [elementData]="el"></app-inbuilt-table-v2>
    </div>
    <div *ngIf="elementType=='metrics'">
        <app-inbuilt-matrix [Temp]="true" [elementData]="el"></app-inbuilt-matrix>
    </div>
    <div *ngIf="elementType=='drill_down_matrix'">
        <app-inbuilt-drill-down-matrix [Temp]="true" [elementData]="el"></app-inbuilt-drill-down-matrix>
    </div>
    <div *ngIf="elementType=='parent_child_table'">
        <app-parent-child-table [Temp]="true" [elementData]="el"></app-parent-child-table>
    </div>
    <div *ngIf="elementType=='column_chart'">
        <app-column-chart-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-column-chart-v2>
    </div>
    <div *ngIf="elementType=='bar_chart'">
        <app-inbuilt-bar-chart-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-bar-chart-v2>
    </div>
    <div *ngIf="elementType=='header'">

        <app-inbuilt-header-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-header-v2>
    </div>
    <div *ngIf="elementType=='card'">

        <app-inbuilt-card-v2 [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-card-v2>
    </div>
    <div *ngIf="elementType=='speedometer'">
        <app-inbuilt-speedometer-v2 [Temp]="true" [elementData]="el"></app-inbuilt-speedometer-v2>
    </div>
    <div *ngIf="elementType=='stat_card'">

        <app-inbuilt-stat-card [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stat-card>
    </div>
    <div *ngIf="elementType=='stack_chart'">

        <app-inbuilt-stack-chart [Temp]="true" [elementData]="el"
            (headingResolved)="el.resolvedHeading = $event"></app-inbuilt-stack-chart>
    </div>